import { styled } from '@mui/material/styles';
import Card from '@components/Card';
import { Typography } from '@components/Typography';
import { generateCompanyCardAddress } from '@helpers/companies';

const CardText = styled('p', {
    shouldForwardProp: prop => prop !== 'disabled',
})(({ disabled }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: 0,
    ...(disabled && {
        color: 'rgba(0, 0, 0, 0.38)',
    }),
}));

const GoogleLocationCard = ({ location = {}, selectedLocation, setLocation }) => {
    const isDisabled = location.connected;

    return (
        <Card
            type="radio"
            selected={location.locationId === selectedLocation.locationId && !isDisabled}
            title={location.title}
            value={location.locationId}
            setValue={() => setLocation(location)}
            disabled={isDisabled}
        >
            {location.country && (
                <CardText disabled={isDisabled} style={{ marginBottom: '8px' }}>
                    {generateCompanyCardAddress(location)}
                </CardText>
            )}
            {location.primaryPhoneNumber && (
                <CardText disabled={isDisabled} style={{ marginBottom: 0 }}>
                    {location.primaryPhoneNumber}
                </CardText>
            )}
            {isDisabled && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#fff',
                        backgroundColor: '#416774',
                        padding: '2px 6px',
                        borderRadius: '18px',
                        width: 'fit-content',
                        marginTop: '16px',
                    }}
                >
                    {location.connectedLocationName}
                </Typography>
            )}
        </Card>
    );
};

export default GoogleLocationCard;
